/* tslint:disable */
/* eslint-disable */
/**
 * OasisExplorer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChartsData
 */
export interface ChartsData {
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    transactions_volume?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    escrow_ratio?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    avg_block_time?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    accounts_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    fees?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    operations_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartsData
     */
    reclaim_amount?: number;
}

export function ChartsDataFromJSON(json: any): ChartsData {
    return ChartsDataFromJSONTyped(json, false);
}

export function ChartsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'transactions_volume': !exists(json, 'transactions_volume') ? undefined : json['transactions_volume'],
        'escrow_ratio': !exists(json, 'escrow_ratio') ? undefined : json['escrow_ratio'],
        'avg_block_time': !exists(json, 'avg_block_time') ? undefined : json['avg_block_time'],
        'accounts_count': !exists(json, 'accounts_count') ? undefined : json['accounts_count'],
        'fees': !exists(json, 'fees') ? undefined : json['fees'],
        'operations_count': !exists(json, 'operations_count') ? undefined : json['operations_count'],
        'reclaim_amount': !exists(json, 'reclaim_amount') ? undefined : json['reclaim_amount'],
    };
}

export function ChartsDataToJSON(value?: ChartsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'transactions_volume': value.transactions_volume,
        'escrow_ratio': value.escrow_ratio,
        'avg_block_time': value.avg_block_time,
        'accounts_count': value.accounts_count,
        'fees': value.fees,
        'operations_count': value.operations_count,
        'reclaim_amount': value.reclaim_amount,
    };
}


